<template>
  <div>
    <el-table :data="attachments.filter(data => !search || data.file_relation.receipt_ships.toString().includes(search.toLowerCase()))" 
            :key="0" stripe v-loading="loading" :element-loading-text="loadingText"
            fit highlight-current-row>
        <el-table-column label="原文件">
            <template slot-scope="scope">
              <span v-show="!isPdfFile(scope.row.name)" class="text-link" v-preview="scope.row.url" :alt="scope.row.name"
                        preview-title-enable="true"
                        preview-nav-enable="true">{{scope.row.name}}</span>
              <el-link v-show="isPdfFile(scope.row.name)" type="primary" @click="previewPdf(scope.row)">{{scope.row.name }}</el-link>
            </template>
        </el-table-column>
        <el-table-column label="签署文件">
            <template slot-scope="scope">
            <el-link type="primary" @click="previewPdf(scope.row.child_obj)">{{scope.row.child_obj.name }}</el-link>
            </template>
            <template slot-scope="scope">
              <span v-show="!isPdfFile(scope.row.child_obj.name)" class="text-link" v-preview="scope.row.child_obj.url" :alt="scope.row.child_obj.name"
                        preview-title-enable="true"
                        preview-nav-enable="true">{{scope.row.child_obj.name}}</span>
              <el-link v-show="isPdfFile(scope.row.child_obj.name)" type="primary" @click="previewPdf(scope.row.child_obj)">{{scope.row.child_obj.name}}</el-link>
            </template>
        </el-table-column>
        <el-table-column label="相关船舶">
            <template slot-scope="scope">
              <p v-for="(item, i) in scope.row.file_relation.receipt_ships" :key="i">{{ item }}</p>
            </template>
        </el-table-column>
        <el-table-column  label="文件大小" width="100px">
            <template slot-scope="scope">
            <span>{{scope.row.size | formatSize }}</span>
            </template>
        </el-table-column>
        <el-table-column  label="创建日期" width="100px">
            <template slot-scope="scope">
            <span>{{scope.row.create_time | parseTime }}</span>
            </template>
        </el-table-column>
        <el-table-column property="status" label="签署状态" width="100px">
            <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content=getSignTooltip(scope.row)  placement="top">
            <span>{{ scope.row.status === 2 ? '已签署' : 
                        scope.row.status === 1 ? '签署中' : 
                        scope.row.status === 0 ? '未签署' : ''}}</span>
            </el-tooltip>
            </template>
        </el-table-column>
        <!-- 按钮组 -->
        <el-table-column align="right" label="操作">
          <!-- <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="mini"
              placeholder="输入关键字搜索"/>
          </template> -->
          <template slot-scope="scope">
            <el-tooltip effect="light" content="下载原文件" placement="top-start">
                <el-button type="text"
                        @click="download(scope.row)"><i class="el-icon-download"></i></el-button>
            </el-tooltip>
            <el-tooltip effect="light" content="下载已签署文件" placement="top-start">
                <el-button type="text"
                        @click="download(scope.row.child_obj)"><i class="el-icon-download"></i></el-button>
            </el-tooltip>
            <el-tooltip effect="light" content="发送签署" placement="top-start">
                <el-button type="text" v-show="canSend(scope.row) && [1,2].indexOf(scope.row.status) == -1"
                        @click="showDialog(scope.row)"><i class="el-icon-s-claim"></i></el-button>
            </el-tooltip>
            <el-tooltip effect="light" content="签署链接" placement="top-start">
              <el-button type="text" v-show="(scope.row.file_sign.length != 0) && (scope.row.file_sign[0].receiver)"
                        @click="signUrl(scope.row.file_sign[0].id)"><i class="el-icon-link"></i></el-button>
            </el-tooltip>
            <el-tooltip effect="light" content="催签" placement="top-start">
              <el-button type="text" v-show="(scope.row.file_sign.length != 0) && (scope.row.file_sign[0].receiver)"
                        @click="handleUrgeSign(scope.row.file_sign[0].id)"><i class="el-icon-alarm-clock"></i></el-button>
            </el-tooltip>
            <el-tooltip effect="light" content="撤销" placement="top-start">
              <el-button type="text" v-show="(scope.row.file_sign.length != 0) && [0, 1].indexOf(scope.row.file_sign[0].sign_flow_status) !== -1"
                        @click="handleRevokeSign(scope.row.file_sign[0].id)"><i class="el-icon-s-release"></i></el-button>
            </el-tooltip>
            <el-tooltip effect="light" placement="top-start" content="删除">
                <el-button type="text" v-show="scope.row.status === null"
                @click="handleDelete(scope.row)" >
                <i class="el-icon-delete"></i>
                </el-button>
            </el-tooltip>
            <el-tooltip effect="light" content="上传已签署" placement="top-start" v-show="!scope.row.child">
                <el-upload
                style="display: inline-block; margin-left: 8px;"
                action=""
                :auto-upload=true
                :http-request="handleUploadFile"
                :show-file-list="false"
                :file-list="file_list"
                :limit="1">
                <el-button type="text" @click="() => {file_id = scope.row.id; object_id = scope.row.file_relation.object_id}"><i class="el-icon-upload2"></i></el-button>
                </el-upload>
            </el-tooltip>
          </template>
        </el-table-column>
    </el-table>

    <el-dialog title="签署人选择" :visible.sync="dialogFormVisible" :show-close="false" v-loading="loading">
      <el-form label-position="left" label-width="150px">
        <el-form-item label="签署方类型">
          <el-radio-group v-model="signer_type">
            <el-radio :label="0">个人</el-radio>
            <el-radio :label="1">公司</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="签署人">
          <el-select v-model="signer_mobile" filterable placeholder="请选择签署人">
            <el-option v-for="contact in contacts" :key="contact.id" 
            :label="contact.name + '(' + restricted_mobile(contact.mobile) + ')'"
            :value="contact.mobile"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="signer_type === 1" label="签署方公司名称">
          <el-select v-model="signer_org_name" filterable placeholder="请选择签署方公司名称">
            <el-option v-for="org in org_list" :key="org.id"
                :label="org.name" :value="org.name"></el-option>
          </el-select>
        </el-form-item>
       
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelSend">取 消</el-button>
        <el-button :disabled="signer_mobile === ''" type="primary" @click="sendSign">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="pdfname" :visible.sync="previewVisible">
      <vue-pdf-preview :url="pdfUrl"></vue-pdf-preview>
    </el-dialog>
  </div>
</template>

<script>
import { formatCurrency, formatSize } from '@/utils/misc'
import {download, getSignTooltip} from '@/utils'
import {signFile, deleteFile, urgeSign, revokeSign, getSignUrl} from '@/api/sign'
import {uploadChildFile} from "@/api/upload"
import { fetchAllContacts } from "@/api/contact"
import VuePdfPreview from "@/components/VuePdfPreview"
import { fetchReceiptPolicyTableFileList } from "@/api/receipt"
import {fetchCustomerContactList, fetchCustomer} from '@/api/customer'

export default {
  name: "file-sign-list",
  components: {
    VuePdfPreview
  },
  props: {
    attachments: Array,
    object_type: String,
    object_id:Number,
    old_object_id:Number,
  },
  filters: {
    formatSize
  },
  data() {
    return {
      loading: false,
      loadingText: '正在加载数据，请稍等...',
      file_id: '',
      // attachments: [],
      file_list: [],
      dialogFormVisible: false,
      contacts: [],
      org_list: [],
      old_contacts:[],
      signer_mobile: '',
      signer_type: 0,
      signer_org_name: '',
      file: {},
      previewVisible: false,
      pdfname: '',
      pdfUrl: '',
      // object_id: '',
      search: ''
    }
  },
  methods: {
    download,
    getSignTooltip,
    restricted_mobile(mobile) {
      if (mobile && !this.$perm(['contact.list_contact']) && !this.$perm(['contact.all_contact']) && this.$perm(['contact.restricted_list_contact'])) {
        let value = mobile.slice(0, 3)
        var l = mobile.slice(3, 7).length
        for (var i=0; i<l; i++) {
          value += '*'
        }
        value += mobile.slice(7)
        return value
      }
      return mobile
    },
    loadData() {
    },
    canSend(row) {
      let can = false
      if (row.file_sign.length == 0) {
        can = true
      }
      else if (! row.file_sign[0].receiver || row.file_sign[0].sign_flow_status === 3) {
        can = true
      }
      return can
    },
    showDialog(row) {
      let p = []
      p.push(fetchCustomerContactList(this.object_id))
      p.push(fetchCustomer(this.object_id))
      // if (this.object_type == "group_insurance.insuranceapply"){
      //   p.push(fetchCustomerContactList(this.object_id))
      // }
      // else{
      //   p.push(fetchAllContacts())
      // }
      if (this.old_object_id && this.object_id !== this.old_object_id){
        p.push(fetchCustomerContactList(this.old_object_id))
      }
      Promise.all(p)
      .then(res => {
        this.contacts = res[0]
        this.org_list = res[1].type === '0' ? [{id: res[1].id, name: res[1].name}] : []
        this.dialogFormVisible = true
        this.file = row
        let contacts_list = []
        this.contacts.forEach(item => {
              contacts_list.push(item.id)
        })
        if (this.old_object_id && this.object_id !== this.old_object_id){
          res[2].forEach(item => {
            if (contacts_list.indexOf(item.id) === -1){
              this.contacts.push(item)
              }
        })
        }
        this.$nextTick(() => {
          if (this.$refs.fileTable) {
            this.$refs.fileTable.clearSelection()
          }
        })
      })
      .catch(err => {
        this.$error_message(err)
      })
    },
    isPdfFile(filename) {
      var is_pdf = false;
      //获取最后一个.的位置
      var index = filename.lastIndexOf(".");
      //获取后缀
      var ext = filename.substr(index+1);
      //判断是否pdf
      if (['pdf'].indexOf(ext.toLowerCase()) !== -1) {
        is_pdf = true
      }
      return is_pdf
    },
    
    handleCancelSend() {
      this.dialogFormVisible = false
      this.signer_mobile = ''
      this.file = {}
    },
    sendSign() {
      const text = '是否发送文书' + '《' + this.file.name + '》至' + this.restricted_mobile(this.signer_mobile) + '进行签署？'
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$set(this.file, 'signer_mobile', this.signer_mobile)
        this.$set(this.file, 'file_type', this.object_type)
        this.$set(this.file, 'signer_type', this.signer_type)
        this.$set(this.file, 'signer_org_name', this.signer_type === 1 ? this.signer_org_name : '')
        this.loading = true
        signFile(this.file)
        .then(res => {
          this.loading = false
          // console.log(res)
          this.$message({
            type: 'success',
            message: '已通知手机号为: ' + this.restricted_mobile(this.signer_mobile) + ' 的客户进行签署'
          });
          location.reload(true)
        })
        .catch((err) => {
          this.loading = false
          this.$message.error({
            message: err
          });
          location.reload(true)
        })

        this.dialogFormVisible = false
        // location.reload(true)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消发送签署'
        });       
      });
    },
    handleUploadFile(param) {
      let file = param.file
      let fd = new FormData()

      fd.append("file", file)
      fd.append("object_id", this.object_id)
      fd.append("object_type", this.object_type)
      fd.append("new_name", file.name)
      fd.append("org_file_id", this.file_id)
      uploadChildFile(fd)
        .then(res => {
          param.onSuccess(res)
          location.reload() 
        })
        .catch(error => {
          param.onError(error)
          error_message(error)
        })
    },
    previewPdf(file){
      this.pdfname = file.name
      this.pdfUrl = file.url
      this.previewVisible = true
    },
    handleDelete(row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.loading = true
        deleteFile({'id': row.id, 'type':this.object_type}).then(res => {
          this.loading = false
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          location.reload()
        }).catch(err => {
          this.loading = false
          this.$error_message(err)
        })
      })
    },
    handleUrgeSign(sign_id) {
      urgeSign(sign_id)
      .then(res => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '已发送催签短信'
          })
        }
        else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    signUrl(sign_id) {
      getSignUrl(sign_id)
      .then(res => {
        if (res.code === 0) {
          this.$alert('签署链接为：' + res.data.shortUrl)
        }
        else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    handleRevokeSign(sign_id) {
      this.$confirm('是否撤销签署', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        revokeSign({'sign_id': sign_id}).then(res => {
          this.loading = false
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '已撤销签署'
            })
            location.reload(true)
          }
          else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        }).catch(err => {
          this.loading = false
          console.log(err)
        })
      })
    }
  }
}
</script>